export default __webpack_public_path__ + "media/icon_1.25bde551.svg";